module.exports = __webpack_public_path__ + "static/media/vanessa-tellez.1be757a9.jpg";